import React, {useEffect, useState} from "react";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import Loading from "../../../components/Loading/LoadingEffect";
import {getLottoGraphData} from "../../../controllers/V1/statisticsReports/statisticsReportsController";
import { list as campaignList } from "../../../controllers/V1/cms/campaignController";
const Recent_order = () => {
  const [isLoading, setIsLoading]= useState(false);
  const [totalSales, setTotalSales] = useState(0);
  const [graphType, setGraphType] = useState('bar');
  const [campaignData, setCampaignData] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [filter, setFilter] = useState({
    start_date: moment().subtract(1,'days').format('YYYY-MM-DD'),
    start_time: '21:31',
    end_date: moment().format('YYYY-MM-DD'),
    end_time: '21:30',
  });

  const [hour, setHour] = useState([]);
  const [count, setCount] = useState([]);

  const formatLabel = (itemId) => {
    if (itemId?.date != null && itemId?.hour != null) {
      const dateLabel = moment(itemId.date).format('DD MMM YYYY');
      const hourStart = moment(`${itemId.date} ${itemId.hour}:00:00`).add(3, 'hours').format('hh A');
      const hourEnd = moment(`${itemId.date} ${itemId.hour}:00:00`).add(4, 'hours').format('hh A');
      return `${dateLabel}, ${hourStart} - ${hourEnd}`;
    }
    if (typeof itemId === 'number' || /^\d{1,2}$/.test(String(itemId))) {
      const baseDate = filter.start_date;
      const hourStart = moment(`${baseDate} ${itemId}:00:00`).add(3, 'hours').format('hh A');
      const hourEnd = moment(`${baseDate} ${itemId}:00:00`).add(4, 'hours').format('hh A');
      return `${moment(baseDate).format('DD MMM YYYY')}, ${hourStart} - ${hourEnd}`;
    }
    return itemId;
  };

  const getData = async () => {
    setIsLoading(true);
    try {
      const option = {
        ...filter,
        ...(selectedCampaign && {campaign_data : selectedCampaign})
      }
      const res = await getLottoGraphData(option);
      if (res.status === true) {
        if (res.result?.length > 0) {
          let points = 0;
          const hours = [], counts = [];

          res.result.forEach(item => {
            hours.push(formatLabel(item._id));
            counts.push(item.count);
            const itemPoints = parseFloat(item.total_points) || 0;
            points = itemPoints + points;
          });

          setHour(hours);
          setCount(counts);
          setTotalSales(points);
        } else {
          setHour(['No order found!']);
          setCount([0]);
          setTotalSales(0);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setHour(['No order found!']);
      setCount([0]);
      setTotalSales(0);
    }
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((pre) => ({ ...pre, [name]: value }));
  };

  const getCampaignList = async () => {
    try {
      const options = {
        condition : {
          status : "A",
          prizeData : {$exists : true},
          settingData : {$exists : true}
        },
        select : { title : true },
        limit : 50
      }
      const res = await campaignList(options);
      if(res?.status === true){
        setCampaignData(res?.result);
      }
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    getCampaignList();
  },[])

  useEffect(()=>{
    getData();
  },[filter, selectedCampaign])

  const handleCampaignChange = async (e) => {
    try {
      const { value } = e.target;
      setSelectedCampaign(value);
    } catch (error) {
      
    }
  }


  const series = [{ name: "Sales", data: count }];

  const options = {
    chart: { height: 350, type: graphType, toolbar: { show: true } },
    colors: ['#C51020'],
    plotOptions: { bar: { borderRadius: 6, columnWidth: '52%' } },
    dataLabels: { enabled: false },
    fill: graphType === 'area' ? {
      type: 'gradient',
      gradient: { shadeIntensity: 1, opacityFrom: 0.55, opacityTo: 0.05, stops: [0, 100] }
    } : { type: 'solid' },
    stroke: { curve: 'smooth', width: graphType === 'area' ? 2 : 0, colors: ['#C51020'] },
    grid: { borderColor: '#f3eded', strokeDashArray: 4 },
    xaxis: {
      categories: hour,
      labels: {
        rotate: -45,
        rotateAlways: hour.length > 8,
        hideOverlappingLabels: true,
        style: { fontFamily: 'Jost, sans-serif', fontSize: '11px' }
      }
    },
    yaxis: { labels: { style: { fontFamily: 'Jost, sans-serif', fontSize: '12px' } } },
    tooltip: { theme: 'light', style: { fontFamily: 'Jost, sans-serif' } },
  };

  const ctrl = { fontFamily:'Jost,sans-serif', fontSize:'13px', border:'1.5px solid #e8e0e0', borderRadius:'7px', padding:'6px 10px', background:'#fdf8f8', color:'#2d2d2d', outline:'none' };
  const lbl  = { fontSize:'11px', fontWeight:600, color:'#7B0025', textTransform:'uppercase', letterSpacing:'0.4px', marginBottom:'3px', display:'block' };

  return (
    <>
      <div style={{ background:'#fff', borderRadius:'12px', border:'1px solid #ede8e8', overflow:'hidden', boxShadow:'0 2px 12px rgba(61,0,18,0.07)' }}>
        {/* ── Header ── */}
        <div style={{ borderBottom:'1px solid #f0e8e8', padding:'14px 20px', display:'flex', alignItems:'flex-end', gap:'16px', flexWrap:'wrap', justifyContent:'space-between' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
            <div style={{ width:'4px', height:'28px', borderRadius:'4px', background:'linear-gradient(180deg,#C51020,#7B0025)' }} />
            <div>
              <div style={{ fontSize:'16px', fontWeight:700, color:'#3D0012', fontFamily:'Jost,sans-serif' }}>Lotto Orders</div>
              <div style={{ fontSize:'11px', color:'#999', fontFamily:'Jost,sans-serif' }}>Sales by date and hour</div>
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'flex-end', gap:'12px', flexWrap:'wrap' }}>
            <div>
              <span style={lbl}>Chart Type</span>
              <select onChange={(e)=>setGraphType(e.target.value)} style={ctrl}>
                <option value="bar">Bar Chart</option>
                <option value="area">Area Chart</option>
              </select>
            </div>
            <div>
              <span style={lbl}>Campaign</span>
              <select name="campaign" id="campaign" onChange={handleCampaignChange} style={ctrl}>
                <option value="">All Campaigns</option>
                {campaignData?.map((item) => (
                  <option key={item?._id} value={item?._id}>{item?.title}</option>
                ))}
              </select>
            </div>
            <div>
              <span style={lbl}>From Date</span>
              <input type="date" name="start_date" value={filter.start_date} onChange={handleFilterChange} style={ctrl} />
            </div>
            <div>
              <span style={lbl}>From Time</span>
              <input type="time" name="start_time" value={filter.start_time} onChange={handleFilterChange} step="1" style={ctrl} />
            </div>
            <div style={{ alignSelf:'center', color:'#7B0025', fontWeight:700, fontFamily:'Jost,sans-serif', fontSize:'13px', paddingTop:'14px' }}>→</div>
            <div>
              <span style={lbl}>To Date</span>
              <input type="date" name="end_date" value={filter.end_date} onChange={handleFilterChange} style={ctrl} />
            </div>
            <div>
              <span style={lbl}>To Time</span>
              <input type="time" name="end_time" value={filter.end_time} onChange={handleFilterChange} step="1" style={ctrl} />
            </div>
          </div>
        </div>

        {/* ── Chart ── */}
        <div style={{ padding:'16px 20px 0' }}>
          <ReactApexChart options={options} series={series} type={graphType} height={350} />
        </div>

        {/* ── Footer nav ── */}
        <div style={{ borderTop:'1px solid #f0e8e8', padding:'12px 20px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <button type="button"
            onClick={() => setFilter((pre) => ({
              ...pre,
              start_date: moment(pre.start_date).subtract(1, 'days').format('YYYY-MM-DD'),
              end_date: moment(pre.end_date).subtract(1, 'days').format('YYYY-MM-DD'),
            }))}
            style={{ fontFamily:'Jost,sans-serif', fontSize:'13px', fontWeight:600, padding:'7px 18px', border:'1.5px solid #e0cccc', borderRadius:'8px', background:'#fff', color:'#3D0012', cursor:'pointer' }}>
            ← Previous
          </button>
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'11px', color:'#999', fontFamily:'Jost,sans-serif', textTransform:'uppercase', letterSpacing:'0.5px' }}>Total Sales</div>
            <div style={{ fontSize:'20px', fontWeight:700, color:'#3D0012', fontFamily:'Jost,sans-serif', lineHeight:1.2 }}>{totalSales}</div>
          </div>
          <button type="button"
            onClick={() => setFilter((pre) => ({
              ...pre,
              start_date: moment(pre.start_date).add(1, 'days').format('YYYY-MM-DD'),
              end_date: moment(pre.end_date).add(1, 'days').format('YYYY-MM-DD'),
            }))}
            style={{ fontFamily:'Jost,sans-serif', fontSize:'13px', fontWeight:600, padding:'7px 18px', border:'none', borderRadius:'8px', background:'#3D0012', color:'#fff', cursor:'pointer' }}>
            Next →
          </button>
        </div>
      </div>
      <Loading isLoading={isLoading} />
    </>
  );
}

export default Recent_order;
